// Per L18N-01 (ADR-006 amendment 2026-04-24), technical status terms stay in
// English (running / sent / cooldown / banned). This dictionary exists so the
// rest of the codebase reaches one place when it needs to render a state, and
// so future per-state Russian narrative (or :hover tooltip explanations) has a
// single seam to evolve through.

import type { Domain } from './status-buckets.js';

const ACCOUNT_LABELS: Record<string, string> = {
  warming_up: 'warming_up',
  available: 'available',
  cooldown: 'cooldown',
  disabled: 'disabled',
  banned: 'banned',
};

const WAREHOUSE_LABELS: Record<string, string> = {
  active: 'active',
  paused: 'paused',
  disabled: 'disabled',
};

const CAMPAIGN_LABELS: Record<string, string> = {
  draft: 'draft',
  running: 'running',
  paused: 'paused',
  cancelled: 'cancelled',
  completed: 'completed',
};

const CAMPAIGN_ITEM_LABELS: Record<string, string> = {
  pending: 'pending',
  snapshotted: 'snapshotted',
  enqueued: 'enqueued',
  consumed: 'consumed',
  skipped: 'skipped',
};

const TRADE_LABELS: Record<string, string> = {
  queued: 'queued',
  sending: 'sending',
  sent: 'sent',
  accepted: 'accepted',
  cancelled: 'cancelled',
  expired: 'expired',
  declined: 'declined',
  failed: 'failed',
};

const RECIPIENT_LABELS: Record<string, string> = {
  pending: 'pending',
  enqueued: 'enqueued',
  sent: 'sent',
  completed: 'completed',
  quarantined: 'quarantined',
  resolved: 'resolved',
};

const PROXY_LABELS: Record<string, string> = {
  ok: 'ok',
  soft: 'soft',
  down: 'down',
};

const STATUS_LABELS: Record<Domain, Record<string, string>> = {
  account: ACCOUNT_LABELS,
  warehouse: WAREHOUSE_LABELS,
  campaign: CAMPAIGN_LABELS,
  'campaign-item': CAMPAIGN_ITEM_LABELS,
  trade: TRADE_LABELS,
  recipient: RECIPIENT_LABELS,
  proxy: PROXY_LABELS,
};

export const getLabel = (domain: Domain, state: string): string =>
  STATUS_LABELS[domain][state] ?? state;
